export const dropdownData = {
  salutations: ["Mr", "Ms", "Mrs", "Mx"],
  genders: ["Male", "Female", "Transgender"],
  maritalStatuses: ["Single/Unmarried", "Married", "Widowed", "Divorced", "Separated", "Not to be Disclosed"],
  categories: ["Gen", "OBC", "SC", "ST"],
  disabilities: ["Yes", "No"],
  disabilityTypes: ["None","Acid Attack Victims","Autism Spectrum Disorder","Blindness (Visually Impaired)","Cerebral Palsy","Deaf","Deaf and Blindness","Dwarfism","Haemophilia","Hard of Hearing","Intellectual Disability","Leprosy Cured Person","Locomotor Disability","Low-vision","Mental Behavior- Mental Illness, Mental Retardation","Multiple Sclerosis","Muscular Dystrophy","Parkinson's Disease","Sickle Cell Disease","Specific Learning Disabilities","Speech and Language Disability (Speech Impaired)","Thalassemia","Persons with spine deformity/spine injury" ],
  religions: [ "Sikhism","Atheist","Others","Hinduism","Christianity","Islam","Jews","Not to be Disclosed","Buddhism","Zoroastrian","Jainism"],
  states: ["Maharashtra", "Delhi", "Karnataka", "Tamil Nadu", "Gujarat"],
  districts: ["Mumbai", "Pune", "Thane", "Nagpur"],
  idTypes: ["Alternate ID"],
  alternateIdTypes: ["Aadhar ID"
    // "PAN Card","Voter ID Card","Domicile Certificate","ST/SC Certificate","Permanent Residential Certificate (PRC)","Driving License","Ration Card","Birth Certificate issued by govt.","BPL Card","National Population Register (NPR) Card","Identity proof by Gazetted officers","Passport","Jail Identification Card / Number","School leaving certificate / 10th certificate","Letter of domicile from SDM / DM / Govt. authority","Others"
],
  countryCodes: ["+91"],
  constituencies: [
    "ANDAMAN AND NICOBAR ISLANDS Constituency",
    "ANDHRA PRADESH Constituency",
    "ARUNACHAL PRADESH Constituency",
    "ASSAM Constituency",
    "BIHAR Constituency",
    "CHANDIGARH Constituency",
    "CHHATTISGARH Constituency",
    "DADRA AND NAGAR HAVELI Constituency",
    "DAMAN AND DIU Constituency",
    "DELHI Constituency",
    "GOA Constituency",
    "GUJARAT Constituency",
    "HARYANA Constituency",
    "HIMACHAL PRADESH Constituency",
    "JAMMU AND KASHMIR Constituency",
    "JHARKHAND Constituency",
    "KARNATAKA Constituency",
    "KERALA Constituency",
    "LAKSHADWEEP Constituency",
    "MADHYA PRADESH Constituency",
    "MAHARASHTRA Constituency",
    "MANIPUR Constituency",
    "MEGHALAYA Constituency",
    "MIZORAM Constituency",
    "NAGALAND Constituency",
    "ODISHA Constituency",
    "PUDUCHERRY Constituency",
    "PUNJAB Constituency",
    "RAJASTHAN Constituency",
    "SIKKIM Constituency",
    "TAMIL NADU Constituency",
    "TELANGANA Constituency",
    "TRIPURA Constituency",
    "UTTAR PRADESH Constituency",
    "UTTARAKHAND Constituency",
    "WEST BENGAL Constituency"
  ],
  educationLevels: [
    "Not Applicable",
    "B.E./B.Tech",
    "Graduate",
    "DNB",
    "I.T.I",
    "Certificate",
    "Diploma",
    "Ability to read and write",
    "B.Tech",
    "Post Graduate",
    "B.E.",
    "Basic Literacy",
    "D.Pharma",
    "Basic Literacy and Numeracy",
    "12th Class/I.T.I",
    "Advanced Diploma",
    "M.Pharma",
    "B.Sc",
    "Medical Graduate",
    "M.Sc",
    "MD",
    "5th Class",
    "A.M.E/B.E",
    "BBA",
    "12th Class/Diploma",
    "MBA",
    "Post Graduate Diploma",
    "LLB",
    "B.Pharma",
    "B.Com",
    "Certificate-NSQF",
    "MS",
    "6th Class",
    "8th Class",
    "7th Class",
    "10th Class",
    "10th Class/I.T.I",
    "11th Class",
    "12th Class",
    "9th Class",
    "M.Tech",
    "10th Class + I.T.I",
    "M.A",
    "Ph.D."
  ],
  trainingStatuses: ["Experienced"],
  sectors: ["IT", "Healthcare", "Manufacturing", "Retail", "Education"],
  employmentStatuses: [
    "Employed Through Registered Employer", "Opted for Higher Studies", 
    "Self Employed", "Up Skilled", "Employed", "NA", 
    "Employed at Training Partner", "Employed at Other Firm"
  ],
  heardAboutUs: [
    "Friends/Relatives",
    "Poster",
    "SMS",
    "Training Provider",
    "Internet",
    "Government Agency",
    "Radio",
    "Newspaper",
    "Television advertisements",
    "Social Media",
    "Pamphlets",
    "Recorded phone message",
    "Newsletter",
    "Kaushal Mela",
    "Call Center",
    "Rozgar Mela",
    "Others",
    "Event/Workshop"
  ]
};